module.exports = __webpack_public_path__ + "static/media/BIMbg@3x.04da13dd.png";